
import request from '@/utils/edu_request'
// import edu_request from '@/utils/edu_request'

//  历史记录 
export function getUserSearchLog(params) {
  return request({
    url: '/log/log/getUserSearchLog',
    method: 'get',
    params: params
  })
}
// 清除搜索历史
export function delUserSearchLog(params) {
  return request({
    url: '/log/log/delUserSearchLog',
    method: 'get',
    params: params
  })
}

// 搜索名称记录
export function saveUserSearchLog(params) {
  return request({
    url: '/log/log/saveUserSearchLog',
    method: 'get',
    params: params
  })
}
// 历史热搜词 
export function getHotSearch(params) {
  return request({
    url: '/log/log/getHotSearch',
    method: 'get',
    params: params
  })
}
// 课程搜索 /search/lesson/getlistlesson
export function getlistlesson(params) {
  return request({
    url: '/lesson/lesson/getlistLesson',
    method: 'get',
    params: params
  })
}